import {LetterAvatarProps} from './types'
import LetterAvatarView from './LetterAvatarView'
import React from 'react'

const LetterAvatar = (props: LetterAvatarProps): React.ReactElement => {
    const {
        highlight = false,
        length = 1,
        name = undefined,
        size = undefined,
        unread = false,
    } = props

    const shortName = name ? name.substring(0, length) : '?'
    const avatarState = highlight ? 'highlight' : unread ? 'unread' : undefined

    return (
        <LetterAvatarView
            name={name}
            shortName={shortName}
            size={size}
            state={avatarState}
        />
    )
}

export default LetterAvatar
